import { components, GroupBase, MultiValueRemoveProps } from 'react-select';

import { CloseIcon } from '@/components/common/Icons/CloseIcon';

import { DropdownOption } from '../../DropdownInput/typings';

const MultiValueRemove = <
  Option = DropdownOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: MultiValueRemoveProps<Option, IsMulti, Group>,
) => {
  return (
    <components.MultiValueRemove {...props}>
      <CloseIcon boxSize={2.5} />
    </components.MultiValueRemove>
  );
};

export default MultiValueRemove;
